import { Row, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Shops from "../../../components/Multipleshopprofile/Components/Shops/Shops";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import { useState, useEffect, useContext } from "react";
import { images } from "../../../constants";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import BackArrow from "../../../components/backArrow";
import SearchIcon from "@mui/icons-material/Search";
import UserItemShop from "../../../components/UserShopItem/UserItemShop";
import { ShopContext } from "../../../config/shopContext";
import { useLazyGetFilteredPropertiesQuery } from "../../../features/property/propertyApiSlice";
import { useLazyGetShopCategoriesQuery, useGetWorldCitiesQuery } from "../../../features/shop/shopApiSlice";
import "./buySingleProperty.css";

const BuySingleProperty = () => {
  /* ================= SHOP CONTEXT ================= */
  const shopType = "singleProperty";
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  /* ================= ORIGINAL STATES ================= */
  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);
  const [open, setOpen] = useState(getcountry);
  const [data, setData] = useState(0);
  const [shopdata, setShopdata] = useState(currentData?.shopdata || []);

  const [selectedSegment, setSelectedSegment] = useState("custom");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");

  const handleSearchChange = (event) => setSearchTerm(event.target.value);
  const handleCountryChange = (event) => setSelectedCountry(event.target.value);
  const handleSearchChangestate = (event) => setSearchTermone(event.target.value);
  const handleSearchChangecity = (event) => setSearchTermtwo(event.target.value);
  const handleCountryChangestate = (event) => setSelectedstateone(event.target.value);
  const handleCountryChangecity = (event) => setSelectedcity(event.target.value);

  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);

  const handleSegmentChange = (value) => setSelectedSegment(value);

  /* ================= COUNTRY / STATE / CITY ================= */
  const { data: worldCitiesRes } = useGetWorldCitiesQuery();

  useEffect(() => {
    if (worldCitiesRes) {
      SetCountrydata(worldCitiesRes);
    }
  }, [worldCitiesRes]);

  const country = [...new Set(countrydata.map((item) => item.country))].sort();

  const handleCountry = (e) => {
    let states = countrydata.filter((state) => state.country === e.target.value);
    states = [...new Set(states.map((item) => item.subcountry))].sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter((city) => city.subcountry === e.target.value);
    setGetcity(cities);
  };

  /* ================= CATEGORY STATE ================= */
  const [dataCategory, setDataCategory] = useState({
    categoryid: "",
  });
  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  const Handledata = (e) => {
    setDataCategory((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const [additionalShopCategoryData, setAdditionalShopCategoryData] = useState(
    currentData?.additionalData || {
      isShop: false,
      categoryid: "",
      subCategoryid: "",
      shopCategory: "",
      country: "",
      state: "",
      city: "",
      saletype: "",
      min: "",
      max: "",
    }
  );

  useEffect(() => {
    setAdditionalShopCategoryData((prev) => ({
      ...prev,
      categoryid: categoryidone || "",
    }));
  }, [categoryidone]);

  const Handleadditioanalshop = (e) => {
    setAdditionalShopCategoryData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  /* ================= FILTER LOGIC WITH CONTEXT ================= */
  const buildQuery = (obj, extra = {}) => {
    const params = { ...extra };
    Object.entries(obj).forEach(([k, v]) => {
      if (v !== "" && v !== undefined && v !== null) params[k] = v;
    });
    return new URLSearchParams(params).toString();
  };

  const [getFilteredProperties, { isLoading }] = useLazyGetFilteredPropertiesQuery();

  const GetFIlterData = () => {
    const queryParams = { filtermethod: "propertyads", businessType: "singleAds" };
    Object.entries(additionalShopCategoryData).forEach(([k, v]) => {
      if (v !== "" && v !== undefined && v !== null) queryParams[k] = v;
    });

    const queryString = new URLSearchParams(queryParams).toString();

    getFilteredProperties(queryString)
      .unwrap()
      .then((res) => {
        if (res) {
          setShopdata(res?.property || []);
          updateFilteredData(
            shopType,
            res?.property || [],
            [],
            { property: additionalShopCategoryData }
          );
        }
      })
      .catch((err) => console.log(err));
  };

  /* ================= MODAL ================= */
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  /* ================= CATEGORY FETCH ================= */
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();

  const [getShopCategories] = useLazyGetShopCategoriesQuery();

  useEffect(() => {
    getShopCategories({ type: "property", parentCategory: "" })
      .unwrap()
      .then((res) => res?.success && setShopCategory(res?.data?.Category))
      .catch((err) => console.log("servicesCategories", err));
  }, []);

  const Mydata = () => {
    if (dataCategory?.categoryid) {
      getShopCategories({ type: "property", parentCategory: categoryName })
        .unwrap()
        .then((res) => res?.success && setShopCategorytwo(res?.data?.Category))
        .catch((err) => console.log("servicesCategories", err));
    }
  };
  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />
      <Container>
        <div>
          <BackArrow back="/BuyingSide " mystyle="buy-single-property-mobile-back d-lg-none" />
          <Row className="buy-single-property-row">
            <Col lg="4" className="screenHeight">
              <div className="border b-radius height_100 ">
                <div className="  background-image">
                  <div className="d-flex bg-primary-one pt-2 pb-2 mb-1 ps-3">
                    <div>
                      <img
                        className="w-imgone"
                        src={images.WorldSearchtwo}
                        alt="web"
                      />
                    </div>
                    <div>
                      <h6 className="titleText pt-1 ps-2 mb-0">
                        Search Category, Area & Desired Location
                      </h6>
                    </div>
                  </div>

                  <div className="px-3 pt-2">
                    <div>
                      <Form.Label className="custm-lble">
                        Search by Category
                      </Form.Label>

                      <Form.Select
                        aria-label="Default select example"
                        name="categoryid"
                        onChange={(e) => {
                          Handledata(e);
                        }}
                      >
                        <option disabled selected>
                          Select Category
                        </option>
                        {shopCategory?.map((category) => (
                          <>
                            <option
                              key={category._id}
                              value={`${category?._id}.${category?.name}`}
                            >
                              {category?.name}

                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </div>

                    <div>
                      <Form.Label className="custm-lble">
                        Search By Sub Category
                      </Form.Label>
                      {/* <Form.Select
                        className="custom-fix-one"
                        placeholder="Sub-Category"
                      >
                        <option> select Category</option>
                      </Form.Select> */}
                      <Form.Select
                        aria-label="Default select example"
                        name="subCategoryid"
                        onChange={(e) => {

                          Handleadditioanalshop(e);
                        }}
                        onClick={Mydata}
                      >
                        <option disabled selected>
                          Select Sub-Category
                        </option>

                        {shopCategorytwo?.map((subcategory) => (
                          <>
                            <option key={subcategory._id} value={subcategory?._id}>
                              {subcategory?.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </div>
                    <div>
                      <Form.Label className="custm-lble">
                        Sale/Rent/Lease
                      </Form.Label>{" "}
                      <br></br>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="saletype"
                          id="inlineRadio1"
                          value="Sale"
                          onChange={(e) => {
                            Handleadditioanalshop(e);
                          }}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Sale
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="saletype"
                          id="inlineRadio2"
                          value="Rent"
                          onChange={(e) => {
                            Handleadditioanalshop(e);
                          }}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          Rent
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="saletype"
                          id="inlineRadio3"
                          value="Lease"
                          onChange={(e) => {
                            Handleadditioanalshop(e);
                          }}
                        />
                        <label className="form-check-label" for="inlineRadio3">
                          Lease
                        </label>
                      </div>{" "}
                    </div>

                    <div>
                      <Form.Label className="custm-lble pt-3">
                        Search by Location
                      </Form.Label>
                    </div>

                    <div className="col-md-12">
                      <label
                        htmlFor="inputPassword4"
                        placeholder="First name"
                        className="form-label labelSize"
                      >
                        Country*
                      </label>
                      <div className="blood-type custom-fix-one p-2">
                        {/* <div className="d-flex">
                          <div className="w-100">
                            <input
                              type="search"
                              value={searchTerm}
                              onChange={handleSearchChange}
                              placeholder="Search country here...."
                              className="w-100 search-input"
                              onClick={() => setHidefield(0)}
                            />
                          </div>
                          <div>
                            <span>
                              <SearchIcon className="search-icon-fs" />
                            </span>
                          </div>
                        </div> */}

                        <select
                          onClick={() => setHidefield(1)}
                          value={selectedCountry}
                          name="country"
                          onChange={(e) => {
                            handleCountryChange(e);
                            handleCountry(e);
                            Handleadditioanalshop(e);
                          }}
                          className="b-radius selectSize w-100"

                        >
                          {hidefield && <option>Select country</option>}

                          {country
                            .filter((country) =>
                              country
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            )
                            .map((country, index) => (
                              <option key={country} value={country}>
                                {country}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <label
                        htmlFor="inputPassword4"
                        placeholder="First name"
                        className="form-label labelSize"
                      >
                        State*
                      </label>
                      <div className="blood-type custom-fix-one p-2">
                        {/* <div className="d-flex">
                          <div className="w-100">
                            <input
                              type="search"
                              value={searchTermone}
                              onChange={handleSearchChangestate}
                              placeholder="Search state here...."
                              className="w-100 search-input"
                              onClick={() => setHidestate(0)}
                            />
                          </div>
                          <div>
                            <span>
                              <SearchIcon className="search-icon-fs" />
                            </span>
                          </div>
                        </div> */}

                        <select
                          onClick={() => setHidestate(1)}
                          className="b-radius selectSize w-100"
                          value={selectedstateone}
                          aria-label="Default select example "
                          name="state"
                          onChange={(e) => {
                            handleState(e);
                            handleCountryChangestate(e);
                            Handleadditioanalshop(e);
                          }}
                        >
                          {hidestate && <option>Select state</option>}
                          {/* <option>
                            {Open === undefined
                              ? "Select Country First"
                              : "select state"}
                          </option> */}

                          {getState
                            .filter((country) =>
                              country
                                .toLowerCase()
                                .includes(searchTermone.toLowerCase())
                            )
                            .map((country) => (
                              <option key={country} value={country}>
                                {country}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label
                        htmlFor="inputPassword4"
                        placeholder="First name"
                        className="form-label labelSize"
                      >
                        City
                      </label>
                      <div className="blood-type custom-fix-one p-2">
                        {/* <div className="d-flex">
                          <div className="w-100">
                            <input
                              type="search"
                              value={searchTermtwo}
                              onChange={handleSearchChangecity}
                              placeholder="Search city here...."
                              className="w-100 search-input"
                              onClick={() => setHidecity(0)}
                            />
                          </div>
                          <div>
                            <span>
                              <SearchIcon className="search-icon-fs" />
                            </span>
                          </div>
                        </div> */}

                        <select
                          onClick={() => setHidecity(1)}
                          value={selectedcity}
                          className="b-radius selectSize w-100"
                          aria-label="Default select example"
                          name="city"
                          onChange={(e) => {
                            handleCountryChangecity(e);
                            Handleadditioanalshop(e);
                          }}
                        >
                          {/* <option>
                              {city === undefined
                                ? "Select State First"
                                : "Select City"}
                            </option> */}

                          {hidecity && <option>Select city</option>}

                          {getcity
                            .filter((country) =>
                              country.name
                                .toLowerCase()
                                .includes(searchTermtwo.toLowerCase())
                            )
                            .map((country) => (
                              <option key={country.name}>{country.name}</option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <Form.Label className="custm-lble pt-2 mb-0">
                        Price Filter
                      </Form.Label>
                      <Row className="d-flex mt-2 gx-2">
                        <Col xl={6} lg={6} md={6} sm={6} xs={6} className="d-flex align-items-center mb-1">
                          <Form.Label className="custm-lble pt-1 pe-1 mb-0">
                            Min
                          </Form.Label>
                          <div className="inputSetting w-100">
                            <input placeholder="" type="number"
                              name="min"
                              onChange={(e) => Handleadditioanalshop(e)}
                            />
                          </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={6} className="d-flex align-items-center mb-1">
                          <Form.Label className="custm-lble pt-1 pe-1 mb-0">
                            Max
                          </Form.Label>
                          <div className="inputSetting w-100">
                            <input placeholder="" type="number"
                              name="max"
                              onChange={(e) => Handleadditioanalshop(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="pt-3 pb-2 d-flex justify-content-center">
                      <button
                        className="btn-lg bg-blue text-white"
                        onClick={GetFIlterData}
                      >
                        Search
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </Col>

            <Col lg="8" className="screenHeight ">
              <div className="border b-radius ps-3 pe-3">
                <BackArrow back="/BuyingSide " mystyle="ps-2 pt-1 d-none d-lg-block" />
                <ShopAdds />
                <UserItemShop
                  title="Property"
                  data={data}
                  handleShow={handleShow}
                  shopdata={shopdata}
                  isDynamic={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
export default BuySingleProperty;
